import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideApiConfiguration } from './generated/api-configuration';
import { environment } from '../../../environments/environment';

/**
 * Registers the generated Tinite API client with the Angular DI tree.
 *
 * @remarks
 * Call this once inside `appConfig.providers` in `app.config.ts`.
 * It wires `environment.apiUrl` into `ApiConfiguration.rootUrl` so that all
 * generated API functions ({@link Api}, `fn/user/*`, `fn/server/*`, `fn/admin/*`)
 * resolve requests against the correct backend host without any per-service
 * configuration.
 *
 * In production `environment.apiUrl` is `'/api/v2'` — the version prefix is
 * part of the base URL so endpoint paths are relative (e.g. `/auth/token`).
 * In local dev (`npm run dev`) the Angular CLI dev-server proxy forwards
 * `/api/*` to `http://localhost:9090`.
 *
 * @returns Angular environment providers for the API client.
 *
 * @example
 * ```ts
 * // app.config.ts
 * export const appConfig: ApplicationConfig = {
 *   providers: [
 *     provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
 *     provideApi(),
 *   ]
 * };
 * ```
 */
export function provideApi(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideApiConfiguration(environment.apiUrl),
  ]);
}
